import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export function toNgbDate(date: Date): NgbDate | null {
    return date
      ? NgbDate.from({
          day: date.getDate(),
          month: date.getMonth() + 1,
          year: date.getFullYear(),
        })
      : null;
  }